import React, { useState } from "react";
import axios from "axios";
import { API_BASE } from "../../apiConfig";
import { useNavigate } from "react-router-dom";

export default function AdminLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const login = async () => {
    try {
      const res = await axios.post(`${API_BASE}/adminLogin.php`, {
        username,
        password,
      });

      if (res.data.status === "success") {
        sessionStorage.setItem("admin_token", res.data.token);
        sessionStorage.setItem("admin", "true");
        sessionStorage.setItem("admin_username", res.data.username);
        navigate("/admin");
      } else {
        alert(res.data.message);
      }
    } catch (err) {
      alert("Login failed!");
    }
  };

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-11 col-md-5">
          <div className="card shadow border-0 rounded-4 p-4">
            <h3 className="fw-bold mb-3 text-center">Admin Login 🔐</h3>

            <input
              className="form-control form-control-lg mb-3"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />

            <input
              className="form-control form-control-lg mb-3"
              placeholder="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <button className="btn btn-primary btn-lg w-100" onClick={login}>
              Login
            </button>
            {/* 
            <div className="text-center mt-3">
              <small className="text-muted">Default: admin / admin123</small>
            </div> */}
            <div className="text-center mt-3">
              <small className="text-muted">
                New Admin?{" "}
                <a href="/admin-register" className="text-decoration-none">
                  Register here
                </a>
              </small>
            </div>
            <div className="text-center mt-3">
              <small className="text-muted">
                Super Admin?{" "}
                <a href="/superadmin-login" className="text-decoration-none">
                  Login here
                </a>
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
